// Professional Title Case for user-entered names, regardless of how they were saved.
export function titleCase(s) {
  if (!s) return "";
  return String(s).trim().toLowerCase().replace(/\b[\p{L}]/gu, (c) => c.toUpperCase());
}
